<template>
  <pt-integral-task-detail class="pt-integral-task-detail__page"></pt-integral-task-detail>
</template>

<script>
import PtIntegralTaskDetail from 'cps/integral-mall-manage/pt-integral-task/pt-integral-task-detail/withData'
export default {
  name: 'pt-integral-task-detail__view',
  components: {
    'pt-integral-task-detail': PtIntegralTaskDetail
  }
}
</script>
